var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app flex-row align-items-center" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "clearfix" }, [
            _c("h1", { staticClass: "float-left display-3 mr-4 white" }, [
              _vm._v("\n            404\n          "),
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "pt-3 white" }, [
              _vm._v("\n            Oops! You're lost.\n          "),
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "text-muted white" },
              [
                _c("router-link", { attrs: { to: "/" } }, [
                  _vm._v("\n              Take me home.\n            "),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }